module.exports = __webpack_public_path__ + "img/1f9c7.aacd8f9.svg";